import React from 'react';

import PageContentWrap from './PageContentWrap';
import PageContent from './PageContent';
import Page from './index';
import LoaderFallback from '../../Feedback/Loader/LoaderFallback';

const PageEmptyLoader = () => (
  <Page isEmpty>
    <PageContentWrap>
      <PageContent>
        <LoaderFallback />
      </PageContent>
    </PageContentWrap>
  </Page>
);

export default PageEmptyLoader;
